import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import React from 'react';
import { useDispatch } from 'react-redux';
import { doSetupAseClosed } from 'store/actions';

import { TemplatesListScreen } from './TemplatesListScreen';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.SETTINGS],
  Screens.SETTINGS_ASSESSMENTS
>;

export const AssessmentSetupScreen: React.FC<Props> = ({ navigation }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(doSetupAseClosed());
    };
  }, [dispatch]);

  return <TemplatesListScreen navigation={navigation} />;
};
